import { Component, inject } from '@angular/core';
import { WorkFrontService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WorkFrontCreateDto,
  WorkFrontDto,
  WorkFrontExcelDownloadDto,
  WorkFrontUpdateDto,
} from '../proxy/controlling/dtos/work-front';
import { WORKFRONT_CONFIG, WORKFRONT_FIELDS } from './work-front.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-work-front',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, WorkFrontService, ConfirmationService],
  templateUrl: './work-front.html',
  styleUrl: './work-front.scss',
})
export class WorkFront extends BaseHierarchicalCrudComponent<
  WorkFrontDto,
  WorkFrontCreateDto,
  WorkFrontUpdateDto,
  WorkFrontExcelDownloadDto
> {
  service = inject(WorkFrontService);
  config = WORKFRONT_CONFIG;
  fields = WORKFRONT_FIELDS;

  protected prepareUpdateDto(data: any, selected: WorkFrontDto): WorkFrontUpdateDto {
    return {
      name: data.name,
      code: data.code,
      activityId: data.activityId,
      foremanId: data.foremanId,
      workFrontTypeId: data.workFrontTypeId,
      workFrontSize: data.workFrontSize,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WorkFront';
  }
}
